import { RootState } from 'app/store';
import { FC } from 'react';
import { useSelector } from 'react-redux';

export const Blur: FC<{
  children: JSX.Element | JSX.Element[];
}> = ({ children }) => {
  const { isBlurActive } = useSelector((state: RootState) => state.blur);

  return (
    <div className={`${isBlurActive ? 'blur-sm' : ''} transition-all`}>
      {children}
    </div>
  );
};

export default Blur;
